export type PermalinkableThoughtRecord = {
	slug: string | null;
	_firstPublishedAt: string | null;
	_updatedAt: string;
};

export function yearMonthDaySlug(thought: PermalinkableThoughtRecord) {
	const { _firstPublishedAt, _updatedAt, slug } = thought;

	if (!(_firstPublishedAt || _updatedAt) || !slug) return {};

	const date = new Date(_firstPublishedAt || _updatedAt);

	const year = date.toLocaleDateString('it', { timeZone: 'Europe/Rome', year: 'numeric' });
	const month = date.toLocaleDateString('it', { timeZone: 'Europe/Rome', month: '2-digit' });
	const day = date.toLocaleDateString('it', { timeZone: 'Europe/Rome', day: '2-digit' });

	return {
		year,
		month,
		day,
		slug
	};
}

export function isThought(value: unknown): value is ThoughtRecord {
	if (value === null) return false;
	if (typeof value !== 'object') return false;
	if ('__typename' in value && value.__typename === 'ThoughtRecord') return true;

	return false;
}
